//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/Object.js";
import "../Motion/Motion.MotionSession.js";
let d=[[],[[["fileName","posOrientFormat","exportEmptyInputFields","exportUnusedOptions","exportSubmechAsMdef","enablePublish","publishedFolder","objects"],"ExportMdef",{},8,0],[["fileName","posOrientFormat","exportEmptyInputFields","exportUnusedOptions","exportSubmechAsMdef","reportToInfoWindow","enablePublish","publishedFolder","objects"],"ExportMdef1",{},9,0],[["fileName","objects"],"ExportPlmxml",{},2,0]],[]];
SPLM.Motion.MechanismExport = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Motion.MechanismExport";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.MechanismExport.PositionOrientationFormat = Object.freeze({
    "TransformationMatrix" : "TransformationMatrix", "Pqr" : "Pqr", "BryantAngles" : "BryantAngles", "EulerAngles" : "EulerAngles", "EulerParameters" : "EulerParameters", "None" : "None"});

export default SPLM;